import { render } from "./ArenaView3.vue?vue&type=template&id=1683b5dd&scoped=true"
import script from "./ArenaView3.vue?vue&type=script&lang=js"
export * from "./ArenaView3.vue?vue&type=script&lang=js"

import "./ArenaView3.vue?vue&type=style&index=0&id=1683b5dd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1683b5dd"]])

export default __exports__